import React from "react";
import envFile from "../images/envFile.jpg";
import middleware from "../images/middleware.jpg";
// import weth from "../images/weth.jpg";
import datalocations from "../images/datalocations.jpg";
// import attacks from "../images/attacks.jpg";
import hack from "../images/hack.jpg";
import rust from "../images/rust.jpg";
import proxy from "../images/proxy.jpg";
import { BsArrowRightCircle } from "react-icons/bs";

const Blogs = () => {
  const articles = [
    {
      name: "Rust Ownership 101",
      image: rust,
      link: "https://medium.com/@varun-doshi/rust-ownership-101-739c6f7a2b65",
    },
    {
      name: "Forward Proxy in NodeJs",
      image: proxy,
      link: "https://medium.com/@varun-doshi/step-by-step-to-guide-to-building-a-forward-proxy-in-nodejs-d078749f0bdc",
    },
    {
      name: "Nothing is truly private in Smart Contracts",
      image: hack,
      link: "https://medium.com/@varun-doshi/nothing-is-truly-private-in-smart-contracts-ca24e5b9950b",
    },
    // {
    //   name: "Smart Contract Attack Vectors",
    //   image: attacks,
    //   link: "https://medium.com/@varun-doshi/smart-contract-attack-vectors-e37d2d68b0b2",
    // },
    {
      name: "Data locations in Solidity",
      image: datalocations,
      link: "https://medium.com/@varun-doshi/demystifying-data-locations-in-solidity-deb698afeb18",
    },
    // {
    //   name: "wtf is wETH?",
    //   image: weth,
    //   link: "https://varunx.hashnode.dev/wtf-is-weth",
    // },
    {
      name: "The Role of Middleware: Enhancing the Functionality of Your Web Applications",
      image: middleware,
      link: "https://varunx.hashnode.dev/the-role-of-middleware-enhancing-the-functionality-of-your-web-applications",
    },
    {
      name: "Pushed .env to Github",
      image: envFile,
      link: "https://varunx.hashnode.dev/pushed-env-file-to-github",
    },
  ];
  return (
    <div
      name="blogs"
      className="h-full my-20 text-center max-w-7xl m-auto px-4 overflow-hidden"
    >
      <h1
        data-aos="slide-up"
        className="font-rubik font-normal mb-12  text-3xl md:text-6xl text-center text-white border-b-2 border-[#34525c] md:mx-[420px] pb-2 "
      >
        Give it a<span className="text-[#FC5130] font-bold"> Read</span>
      </h1>
      <div
        data-aos="fade-left"
        className="overflow-hidden grid lg:grid-cols-3 grid-cols-1 gap-x-6 md:gap-x-16 gap-y-10 md:gap-y-12 text-center mb-12 pb-6 px-4 md:px-0"
      >
        {articles.map(({ name, image, link }) => (
          <div className={"key={id} text-gray-700  rounded-lg mx-auto "}>
            <div className=" shadow-lg shadow-black h-full w-full text-[#F7F0F5]">
              <img className=" rounded-lg w-[600px] h-48" src={image} alt="/" />

              <h1 className="text-2xl py-2">{`${name.slice(0, 22)}...`}</h1>
              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                className=" mx-auto"
              >
                <BsArrowRightCircle
                  size={40}
                  className=" rounded-full mb-2 hover:text-[#1e1e1e] hover:bg-[#F7F0F5] mx-auto"
                />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
